// src/components/IntercomBoot.jsx
import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAuth0 } from '@auth0/auth0-react';

const APP_ID = 'o3x36plv';

export default function IntercomBoot() {
  const { isAuthenticated, user, isLoading } = useAuth0();

  useEffect(() => {
    if (typeof window === 'undefined' || isLoading) return;

    if (isAuthenticated && user) {
      Intercom({
        app_id: APP_ID,
        user_id: user?.sub,
        name:
          user?.name ||
          [user?.given_name, user?.family_name].filter(Boolean).join(' ') ||
          undefined,
        email: user?.email,
      });
    } else {
      Intercom({ app_id: APP_ID });
    }

    return () => {
      try { window.Intercom && window.Intercom('shutdown'); } catch {}
    };
  }, [isAuthenticated, isLoading, user]);

  return null;
}
